function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import JSZip from 'jszip';
import { toast } from 'react-hot-toast';
import { FILE_TYPES } from '@edusense/shared-project-upload-constants';
/**
 * 파일 트리에서 파일 경로를 추출하는 함수
 */ export var extractFilePaths = function(tree) {
    var currentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var paths = [];
    if (!tree) return paths;
    Object.entries(tree).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var newPath = currentPath ? "".concat(currentPath, "/").concat(key) : key;
        if (value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object') {
            if ('file' in value) {
                paths.push({
                    path: newPath
                });
            } else if ('directory' in value && value.directory) {
                paths = paths.concat(extractFilePaths(value.directory, newPath));
            }
        }
    });
    return paths;
};
/**
 * 파일 트리에서 파일 개수를 세는 함수
 */ export var countFiles = function(tree) {
    var count = 0;
    var traverse = function(node) {
        if (!node) return;
        Object.entries(node).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object') {
                if ('file' in value) {
                    count++;
                } else if ('directory' in value && value.directory) {
                    traverse(value.directory);
                }
            }
        });
    };
    traverse(tree);
    return count;
};
/**
 * 파일 배열을 ZIP 파일로 압축하는 함수
 */ export var createZipFromFiles = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(files) {
        var zip, rootFolderName, firstPath, parts, zipBlob;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    zip = new JSZip();
                    // 첫 번째 파일의 경로에서 루트 폴더명 결정
                    rootFolderName = '';
                    if (files.length > 0) {
                        firstPath = files[0].relativePath || files[0].file.name;
                        parts = firstPath.split('/');
                        if (parts.length > 1) {
                            rootFolderName = parts[0] + '/'; // 후행 슬래시 포함
                        }
                    }
                    files.forEach(function(item) {
                        var originalPath = item.relativePath || item.file.name;
                        // ZIP 내부에서 루트 폴더명 제거
                        var pathInZip = rootFolderName && originalPath.startsWith(rootFolderName) ? originalPath.substring(rootFolderName.length) : originalPath;
                        // pathInZip가 비어있지 않은지 확인
                        if (pathInZip) {
                            zip.file(pathInZip, item.file);
                        }
                    });
                    return [
                        4,
                        zip.generateAsync({
                            type: "blob",
                            compression: "DEFLATE",
                            compressionOptions: {
                                level: 9
                            }
                        })
                    ];
                case 1:
                    zipBlob = _state.sent();
                    return [
                        2,
                        new File([
                            zipBlob
                        ], "project.zip", {
                            type: "application/zip"
                        })
                    ];
            }
        });
    });
    return function createZipFromFiles(files) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 필수 프로젝트 파일들이 포함되어 있는지 검증하는 함수
 */ export var validateRequiredFiles = function(files) {
    var filesToCheck = [
        'package.json',
        'pnpm-lock.yaml'
    ];
    var viteConfigFiles = [
        'vite.config.js',
        'vite.config.ts'
    ];
    var allFilePaths = files.map(function(item) {
        return item.relativePath || item.file.name;
    }).map(function(path) {
        return path.split('/').pop() || '';
    });
    var missingFiles = [];
    var viteConfigFound = false;
    filesToCheck.forEach(function(requiredFile) {
        if (!allFilePaths.includes(requiredFile)) {
            missingFiles.push(requiredFile);
        }
    });
    viteConfigFound = viteConfigFiles.some(function(configFile) {
        return allFilePaths.includes(configFile);
    });
    if (!viteConfigFound) {
        missingFiles.push('vite.config.js 또는 vite.config.ts');
    }
    return {
        isValid: missingFiles.length === 0,
        missingFiles: missingFiles
    };
};
/**
 * 파일이 ZIP 형식인지 확인하는 함수
 */ export var isZipFile = function(file) {
    return FILE_TYPES.ZIP_MIME_TYPES.includes(file.type) || FILE_TYPES.ZIP_EXTENSIONS.some(function(ext) {
        return file.name.toLowerCase().endsWith(ext);
    });
};
export var analyzeZipFile = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(file) {
        var zip, zipBuffer, zipContents, newFileTree, fileList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, relativePath, zipEntry, currentLevel, pathParts, i, part, fileName, fileContent, normalizedPath, err, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        11,
                        ,
                        12
                    ]);
                    toast('ZIP 파일 분석 중...');
                    // ZIP 파일 읽기
                    zip = new JSZip();
                    return [
                        4,
                        file.arrayBuffer()
                    ];
                case 1:
                    zipBuffer = _state.sent();
                    return [
                        4,
                        zip.loadAsync(zipBuffer)
                    ];
                case 2:
                    zipContents = _state.sent();
                    console.log('[analyzeZipFile] ZIP 파일 내용:', Object.keys(zipContents.files));
                    // FileTree 구조로 변환
                    newFileTree = {};
                    fileList = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        8,
                        9,
                        10
                    ]);
                    _iterator = Object.entries(zipContents.files)[Symbol.iterator]();
                    _state.label = 4;
                case 4:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    _step_value = _sliced_to_array(_step.value, 2), relativePath = _step_value[0], zipEntry = _step_value[1];
                    if (!!zipEntry.dir) return [
                        3,
                        6
                    ];
                    // 파일 트리에 추가
                    currentLevel = newFileTree;
                    pathParts = relativePath.split('/');
                    // 마지막 요소를 제외한 모든 부분을 디렉토리로 처리
                    for(i = 0; i < pathParts.length - 1; i++){
                        part = pathParts[i];
                        if (!currentLevel[part]) {
                            currentLevel[part] = {
                                directory: {}
                            };
                        }
                        currentLevel = currentLevel[part].directory;
                    }
                    // 마지막 요소는 파일로 처리
                    fileName = pathParts[pathParts.length - 1];
                    currentLevel[fileName] = {
                        file: true
                    };
                    return [
                        4,
                        zipEntry.async('blob')
                    ];
                case 5:
                    fileContent = _state.sent();
                    normalizedPath = relativePath.replace(/\\/g, '/');
                    fileList.push({
                        file: new File([
                            fileContent
                        ], fileName),
                        relativePath: normalizedPath
                    });
                    _state.label = 6;
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        4
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    console.log('[analyzeZipFile] 생성된 파일 트리:', newFileTree);
                    console.log('[analyzeZipFile] 추출된 파일 목록:', fileList);
                    toast.success('ZIP 파일 분석이 완료되었습니다.');
                    return [
                        2,
                        {
                            fileTree: newFileTree,
                            fileList: fileList
                        }
                    ];
                case 11:
                    error = _state.sent();
                    console.error('[analyzeZipFile] ZIP 파일 처리 중 오류:', error);
                    toast.error('ZIP 파일을 처리하는 중 오류가 발생했습니다.');
                    throw error;
                case 12:
                    return [
                        2
                    ];
            }
        });
    });
    return function analyzeZipFile(file) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 파일 크기를 읽기 쉬운 형식으로 변환하는 함수
 */ export var formatFileSize = function(bytes) {
    if (bytes === 0) return '0 Bytes';
    var k = 1024;
    var sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB'
    ];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
/**
 * 파일 확장자를 기반으로 파일 타입을 결정하는 함수
 */ export var getFileType = function(fileName) {
    var _fileName_split_pop;
    var extension = ((_fileName_split_pop = fileName.split('.').pop()) === null || _fileName_split_pop === void 0 ? void 0 : _fileName_split_pop.toLowerCase()) || '';
    var typeMap = {
        'js': 'JavaScript',
        'ts': 'TypeScript',
        'tsx': 'React TSX',
        'jsx': 'React JSX',
        'json': 'JSON',
        'html': 'HTML',
        'css': 'CSS',
        'scss': 'SCSS',
        'md': 'Markdown',
        'txt': 'Text',
        'png': 'PNG Image',
        'jpg': 'JPEG Image',
        'jpeg': 'JPEG Image',
        'gif': 'GIF Image',
        'svg': 'SVG Image',
        'mp4': 'MP4 Video',
        'webm': 'WebM Video',
        'zip': 'ZIP Archive'
    };
    return typeMap[extension] || 'Unknown';
};
